// @ts-nocheck

import { createSelector } from 'reselect';

import {
  selectHistoryLimit,
  selectHistoryNbBetslips,
  selectHistoryOffset,
} from '../../selectors/history/historyPrimary.selector';

const selectOffset = createSelector([selectHistoryOffset, selectHistoryLimit], (offset, limit) =>
  Math.ceil(offset / limit),
);

const selectNbPages = createSelector([selectHistoryNbBetslips, selectHistoryLimit], (nbBetslips, limit) =>
  Math.ceil(nbBetslips / limit),
);

const selectHistoryPaginationProps = createSelector([selectOffset, selectNbPages], (offset, nbPages) => ({
  offset,
  nbPages,
}));

export default selectHistoryPaginationProps;
